import { Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function GiftIcon(props: IconProps) {
  const clipPathId = useId();
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <g
        clipPath={`url(#${clipPathId}-a)`}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M16.6666 10v8.3333H3.33325V10M18.3334 5.83301H1.66675v4.16666H18.3334V5.83301ZM10 18.333V5.83301" />
        <path d="M10.0001 5.83366H6.25008c-.55253 0-1.08244-.21949-1.47314-.6102-.3907-.3907-.61019-.9206-.61019-1.47313 0-.55254.21949-1.08244.61019-1.47314.3907-.3907.92061-.6102 1.47314-.6102 2.91667 0 3.75002 4.16667 3.75002 4.16667Z" />
        <path d="M10 5.83366h3.75c.5525 0 1.0824-.21949 1.4731-.6102.3907-.3907.6102-.9206.6102-1.47313 0-.55254-.2195-1.08244-.6102-1.47314-.3907-.3907-.9206-.6102-1.4731-.6102-2.9167 0-3.75 4.16667-3.75 4.16667Z" />
      </g>
      <defs>
        <clipPath id={`${clipPathId}-a`}>
          <rect width="20" height="20" fill="#fff" />
        </clipPath>
      </defs>
    </Icon>
  );
}
